import { t } from '@kc-console/core';

export enum LanguageTypeEnum {
  SYSTEM = '',
  KO = 'ko',
  EN = 'en',
}

export function getLanguageLabel(value: LanguageTypeEnum): string {
  const labels: Record<LanguageTypeEnum, string> = {
    [LanguageTypeEnum.SYSTEM]: t('layout:setting.language.browser_default'),
    [LanguageTypeEnum.KO]: t('layout:setting.language.korean'),
    [LanguageTypeEnum.EN]: 'English',
  };
  return labels[value];
}
